export default __webpack_public_path__ + "static/media/customSoftware.52dd69aa.png";